import { ReviewRoomGroup } from '@/src/types/hotels/details'
import { Box, Chip, Typography } from '@mui/material'
import RoomGroupCard from '../roomGroupCard'
import { ReviewContext } from '../roomVariantRow'

export interface RoomFilterChip {
    key: string
    label: string
    active: boolean
}

export interface RoomSelectionSectionProps {
    filterRoomsByLabel: string
    chips: RoomFilterChip[]
    onToggleFilter: (key: string) => void
    filteredGroups: ReviewRoomGroup[]
    variant: 'mobile' | 'desktop'
    noRoomsLabel: string
    reviewContext: ReviewContext
    onSelect: (rId: string, arNo: string) => void
}

// Pure presentation: filter chips + the list of room-type groups (or empty state).
const RoomSelectionSection = ({
    filterRoomsByLabel,
    chips,
    onToggleFilter,
    filteredGroups,
    variant,
    noRoomsLabel,
    reviewContext,
    onSelect
}: RoomSelectionSectionProps) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography sx={{ fontSize: 12, color: 'textColors.secondary' }}>{filterRoomsByLabel}</Typography>
            {chips.map(chip => (
                <Chip
                    key={chip.key}
                    label={chip.label}
                    clickable
                    variant={chip.active ? 'filled' : 'outlined'}
                    onClick={() => onToggleFilter(chip.key)}
                    sx={{
                        bgcolor: chip.active ? 'primary.main' : 'neutral.white',
                        color: chip.active ? 'neutral.white' : 'textColors.primary',
                        borderColor: chip.active ? 'primary.main' : 'borders.heavy',
                        '&:hover': { bgcolor: chip.active ? 'primary.dark' : 'neutral.100' }
                    }}
                />
            ))}
        </Box>

        {filteredGroups.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 6 }}>
                <Typography sx={{ fontSize: 14, color: 'textColors.secondary' }}>{noRoomsLabel}</Typography>
            </Box>
        ) : (
            filteredGroups.map((group, index) => (
                <RoomGroupCard
                    key={`${group.roomName}-${index}`}
                    group={group}
                    variant={variant}
                    reviewContext={reviewContext}
                    onSelect={onSelect}
                />
            ))
        )}
    </Box>
)

export { RoomSelectionSection }
export default RoomSelectionSection
